Ext.ns('mx.plugin');
mx.plugin.dynamicAllowBlank = function(config) {
    Ext.apply(this, config);
};
Ext.extend(mx.plugin.dynamicAllowBlank, Ext.util.Observable, {
    getAsterixElement: function(el) {
        if (el.child('.mx-comp-formlayout-asterix')) {
            return el.child('.mx-comp-formlayout-asterix');
        } else if (el.parent()) {
            return this.getAsterixElement(el.parent());
        }
        return null;
    },
    init: function(component) {
        component.allowBlankPluginScope = this;
        component.AllowBlank = function() {
            this.allowBlank = true;
            var el = this.allowBlankPluginScope.getAsterixElement(Ext.get(this.el));
            if (el) {
                el.setVisibilityMode(Ext.Element.DISPLAY);
                el.hide();

                this.validate();
            }
        };
        component.DisallowBlank = function() {
            this.allowBlank = false;
            var el = this.allowBlankPluginScope.getAsterixElement(Ext.get(this.el));
            if (el) {
                el.show();

                this.validate();
            }
        };
        component.setRequired = function(s) {
            if (s && !this.isHidden) {
                this.DisallowBlank();
            } else {
                this.AllowBlank();
            }
        };

        var originalValidate = component.validate;
        component.validate = function() {
            if (this.getValue() == '') {
                if (this.allowBlank) {
                    this.clearInvalid();
                    return true;
                }
            }
            return originalValidate.call(this);
        };

        if (component.initialAllowBlank) {
            component.on('render', component.AllowBlank);
        }
    },
});
